module.exports = __webpack_public_path__ + "static/media/info_black.061f4087.svg";